import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

export class OpenNewKeywordDialogCommand extends AbstractCommand<void> {

    public name: CommandName = CommandName.OPEN_NEW_KEYWORD_DIALOG;

    public tags = ['ui', 'dialog', 'keyword', 'create'];

    constructor() {
        super('keyword', 'new', undefined);
    }
}